import { SpinResponse } from '@cgs/data-access';
import {
  AbstractSpinConfig,
  GameStateMachine,
  ReelsEngine,
  ReelsSoundModel,
  SpinAction,
  WaitForAction,
} from '@cgs/machines';
import { EmptyAction, FunctionAction, IntervalAction, SequenceAction, Vector2 } from '@cgs/wge';

export class CorsicaFreeSpinAction extends SpinAction {
  constructor(
    engine: ReelsEngine,
    gameStateMachine: GameStateMachine<SpinResponse>,
    regularSpinConfig: AbstractSpinConfig,
    freeSpinConfig: AbstractSpinConfig,
    sounds: ReelsSoundModel,
    useSounds: boolean,
    private lines: number[][]
  ) {
    super(engine, gameStateMachine, regularSpinConfig, freeSpinConfig, sounds, useSounds);
  }

  public getSpinConfig(): AbstractSpinConfig {
    return this._freeSpinConfig;
  }

  public spin(reel: number): IntervalAction {
    if (this.lines[reel].length === 0) {
      return new FunctionAction(() =>
        this.engine.accelerateSingleSpinningReel(reel, Vector2.Zero, Vector2.Zero, 0, [])
      );
    }

    const config = this.getSpinConfig();

    return new FunctionAction(() =>
      this.engine.accelerateSingleSpinningReel(
        reel,
        Vector2.Zero,
        new Vector2(0.0, config.spinSpeed * config.directions[reel]),
        config.accelerationDuration,
        this.lines[reel]
      )
    );
  }

  public buildAction(): IntervalAction {
    const actions: IntervalAction[] = [];

    for (let reel = 0; reel < this.engine.ReelConfig.reelCount; ++reel) {
      if (reel > 0) {
        actions.push(new EmptyAction().withDuration(this.getSpinConfig().spinStartDelay));
      }
      actions.push(this.spin(reel));
    }
    actions.push(new WaitForAction(this.engine.slotsAccelerated));
    return new SequenceAction(actions);
  }
}
